/*
 * @Author: caiqin.xie
 * @since: 2023-06-09 14:56:39
 * @lastTime: 2023-11-08 15:43:41
 * @LastEditors: caiqin.xie
 * @message: 博客左侧游戏banner
 */
import React from "react";
import classnames from 'classnames'
import LazyMedia from "@/components/LazyMedia";
import { useDevice } from "@/hooks";
import styles from "../../index.module.scss";

interface IProps {
  gameBanner: Record<string, any>; // 博客游戏banner
  ctry: string;
  words: Record<string, string>;
}

const GameBanner = (props:IProps) => {
  const {ctry, gameBanner, words} = props
  const device = useDevice()
  const newDevice = (device === '' ? 'pc' : device === 'paid' ? 'pad' : device)
  return (
    <>
     {gameBanner && (
        <div
          className={classnames(styles['blog-left-banner'], styles['blog-game-banner'])}
          onClick={() => gameBanner?.url && window.open(gameBanner?.url)}>
          {
            gameBanner[newDevice].extension === '.mp4'
            ? <LazyMedia LazyClassName="full-wh" type="video" loop autoPlay preload="auto" playsInline muted src={gameBanner[newDevice]?.url}></LazyMedia>
            : <LazyMedia LazyClassName="full-wh" type="image" src={gameBanner[newDevice]?.url} alt={gameBanner[newDevice]?.alt} />
          }
          <div className={styles['left-banner-content']}>
            {gameBanner?.isShowTitle === 1 && (
              <h3 className={styles['banner-title']}>{gameBanner?.name}</h3>
            )}
            <p className={styles['banner-sub-title']}>{gameBanner?.remark}</p>
          </div>
        </div>
     )}
    </>
    
  )
}
export default GameBanner
